export default "__VITE_ASSET__XIS3FdZm__"